// extracted by mini-css-extract-plugin
export default {"parent":"Container_parent__IjCQO","parent__children":"Container_parent__children__3MQBf"};